const map = {
	"./en/account.json": 82937,
	"./en/activity.json": 67399,
	"./en/auth.json": 3664,
	"./en/common.json": 46251,
	"./en/ecosystem.json": 43850,
	"./en/explore.json": 96329,
	"./en/help.json": 94985,
	"./en/home.json": 6953,
	"./en/redPacket.json": 89897,
	"./en/vouchers.json": 56177,
	"./en/wallet.json": 5371,
	"./id/account.json": 6151,
	"./id/activity.json": 10729,
	"./id/auth.json": 78754,
	"./id/common.json": 7053,
	"./id/ecosystem.json": 46776,
	"./id/explore.json": 44887,
	"./id/help.json": 60779,
	"./id/home.json": 89151,
	"./id/redPacket.json": 39203,
	"./id/vouchers.json": 25775,
	"./id/wallet.json": 31857,
	"./ja/account.json": 61547,
	"./ja/activity.json": 7581,
	"./ja/auth.json": 52574,
	"./ja/common.json": 44625,
	"./ja/ecosystem.json": 33460,
	"./ja/explore.json": 86091,
	"./ja/help.json": 94183,
	"./ja/home.json": 59139,
	"./ja/redPacket.json": 90551,
	"./ja/vouchers.json": 66731,
	"./ja/wallet.json": 75173,
	"./ko/account.json": 20888,
	"./ko/activity.json": 68648,
	"./ko/auth.json": 73659,
	"./ko/common.json": 39024,
	"./ko/ecosystem.json": 42911,
	"./ko/explore.json": 19547,
	"./ko/help.json": 55474,
	"./ko/home.json": 89214,
	"./ko/redPacket.json": 46832,
	"./ko/vouchers.json": 12702,
	"./ko/wallet.json": 98168,
	"./th/account.json": 49586,
	"./th/activity.json": 75534,
	"./th/auth.json": 50097,
	"./th/common.json": 77846,
	"./th/ecosystem.json": 57553,
	"./th/explore.json": 66682,
	"./th/help.json": 60472,
	"./th/home.json": 97040,
	"./th/redPacket.json": 48990,
	"./th/vouchers.json": 39896,
	"./th/wallet.json": 15650,
	"./vi/account.json": 25095,
	"./vi/activity.json": 94441,
	"./vi/auth.json": 48194,
	"./vi/common.json": 52717,
	"./vi/ecosystem.json": 77624,
	"./vi/explore.json": 81239,
	"./vi/help.json": 80651,
	"./vi/home.json": 54143,
	"./vi/redPacket.json": 88259,
	"./vi/vouchers.json": 58383,
	"./vi/wallet.json": 15185,
	"./zh-CN/account.json": 99514,
	"./zh-CN/activity.json": 50678,
	"./zh-CN/auth.json": 93497,
	"./zh-CN/common.json": 13438,
	"./zh-CN/ecosystem.json": 82249,
	"./zh-CN/explore.json": 93554,
	"./zh-CN/help.json": 41136,
	"./zh-CN/home.json": 63320,
	"./zh-CN/redPacket.json": 60150,
	"./zh-CN/vouchers.json": 18800,
	"./zh-CN/wallet.json": 48250
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31556;